import { render } from "./IncomeTop.vue?vue&type=template&id=d9071dce&scoped=true"
import script from "./IncomeTop.vue?vue&type=script&lang=js"
export * from "./IncomeTop.vue?vue&type=script&lang=js"

import "./IncomeTop.vue?vue&type=style&index=0&id=d9071dce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9071dce"]])

export default __exports__